module.exports = __webpack_public_path__ + "static/media/InvolvedXs3.dd0e1b43.svg";